import { KeenIcon } from '@/components';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required').max(255),
  description: Yup.string().max(500).nullable(),
  color: Yup.string()
    .nullable()
    .matches(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, 'Enter a valid hex color'),
});

const COLOR_SWATCHES = [
  '#E11D48', '#2563EB', '#D97706', '#9333EA', '#DC2626',
  '#059669', '#7C3AED', '#0891B2', '#4F46E5', '#6B7280',
];

const RecordTypeModal = ({ open, onClose, mode = 'create', data, onSubmit, loading }) => {
  if (!open) return null;

  const initialValues = {
    name: data?.name || '',
    description: data?.description || '',
    color: data?.color || '#6B7280',
    is_active: data?.is_active === undefined ? true : Boolean(data.is_active),
  };

  return (
    <div className="modal-wrapper modal-animate-fade">
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, helpers) => onSubmit(values, helpers)}
      >
        {({ values, handleSubmit, setFieldValue }) => (
          <Form onSubmit={handleSubmit} className="w-4/5 max-w-md modal-animate-scale modal-body">
            <h3 className="mb-5 capitalize card-title">{mode} Record Type</h3>
            <button type="button" onClick={onClose} className="modal-close-btn">
              <KeenIcon icon="cross" />
            </button>

            <div>
              <label className="mb-1 form-label">
                Name <span className="pl-px text-red-600">*</span>
              </label>
              <Field name="name" className="input" placeholder="e.g. Personal Injury" />
              <ErrorMessage name="name" component="div" className="mt-1 text-xs text-red-500" />
            </div>

            <div className="my-4">
              <label className="mb-1 form-label">Description</label>
              <Field
                as="textarea"
                name="description"
                className="input pt-2 h-[70px]"
                placeholder="Shown to users when picking a record type"
              />
              <ErrorMessage name="description" component="div" className="mt-1 text-xs text-red-500" />
            </div>

            <div className="my-4">
              <label className="mb-1 form-label">Color</label>
              <div className="flex items-center gap-2">
                <input
                  type="color"
                  value={values.color}
                  onChange={(e) => setFieldValue('color', e.target.value)}
                  className="w-10 h-10 p-0 border rounded cursor-pointer border-border"
                />
                <Field name="color" className="input" />
              </div>
              <div className="flex flex-wrap gap-1.5 mt-2">
                {COLOR_SWATCHES.map((c) => (
                  <button
                    key={c}
                    type="button"
                    onClick={() => setFieldValue('color', c)}
                    className="w-6 h-6 rounded-full border border-border"
                    style={{ backgroundColor: c }}
                    aria-label={c}
                  />
                ))}
              </div>
              <ErrorMessage name="color" component="div" className="mt-1 text-xs text-red-500" />
            </div>

            <div className="my-4">
              <Field name="is_active">
                {({ field, form }) => (
                  <label className="switch w-fit !gap-1.5">
                    <span className="switch-label !text-xs">Active</span>
                    <input
                      type="checkbox"
                      checked={field.value}
                      onChange={() => form.setFieldValue('is_active', !field.value)}
                    />
                  </label>
                )}
              </Field>
            </div>

            <button type="submit" disabled={loading} className="justify-center w-full mt-2 btn btn-primary">
              {loading ? 'Please Wait...' : mode === 'edit' ? 'Update Record Type' : 'Create Record Type'}
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export { RecordTypeModal };
